import { Nullable } from 'cng-common/models/utils'

export const getSumOfNumbers = (numbers: (Nullable<number> | undefined)[]) => {
  return numbers.reduce<Nullable<number>>((acc, value) => {
    if (value === null || value === undefined) {
      return acc
    }

    if (acc === null) {
      return value
    }

    return acc + value
  }, null)
}
